import { Nullable } from 'legacy/lut/classes/models/utils'
import { KeyInitiativeInitTypes } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/models/keyInitiativeInitTypes'

interface IGetIncrementalFieldName {
  initType: Nullable<KeyInitiativeInitTypes>
  currency?: string
  incrementalFieldNameByValueType?: string
}

const getCurrency = (currency?: string) => {
  if (currency === 'USD') {
    return `Usd`
  } else {
    return `LocalCurrency`
  }
}

export const getIncrementalFieldName = ({
  incrementalFieldNameByValueType,
  initType,
  currency,
}: IGetIncrementalFieldName) => {
  const currentCurrency = initType !== null ? '' : getCurrency(currency)
  return `${incrementalFieldNameByValueType}${currentCurrency}`
}
